"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJHUDScene = void 0;
const CGJGeneralMenuScene_1 = require("./CGJGeneralMenuScene");
const CGJText_1 = require("./CGJText");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
const KHMenuOption_1 = require("./KH/Menu/KHMenuOption");
const KHMenuSpec_1 = require("./KH/Menu/KHMenuSpec");
const KHSimpleListMenu_1 = require("./KH/Menu/KHSimpleListMenu");
class CGJHUDScene extends Phaser.Scene {
    constructor() {
        super("CGJHUDScene");
    }
    create() {
        this.pauseSound = this.sound.add('Tick');
    }
    update(now, delta) {
        var _a;
        (_a = this.listMenu) === null || _a === void 0 ? void 0 : _a.update(now);
    }
    showPauseMenu(reason, callback) {
        this.scene.bringToTop();
        this.pauseSound.play();
        const w = Number(this.game.config.width);
        const h = Number(this.game.config.height);
        // TODO: Non-mouse input doesn't work for some reason.
        const firstOption = reason ? (this.addText(.5, .5, reason)) : (this.addClickableOption(.5, .5, "Resume", () => { this.cleanup(callback, 'resume'); }));
        const menuSpec = new KHMenuSpec_1.KHMenuSpec("", [
            firstOption,
            this.addClickableOption(.5, .8, "Restart", () => { this.cleanup(callback, 'restart'); }),
            this.addClickableOption(.5, .9, "Main Menu", () => { this.cleanup(callback, 'menu'); }),
        ], null);
        this.listMenu = new KHSimpleListMenu_1.KHSimpleListMenu(this, KHInputScene_1.KHInputScene.SharedInput, CGJGeneralMenuScene_1.CGJGeneralMenuScene.makeListInputHandler(this), menuSpec, new Phaser.Geom.Rectangle(0, 0, w, h), [], (menuOption, onPointerOver, onPointerOut, onPointerLeft, onPointerRight, onSelect) => {
            let item = new CGJText_1.CGJText(this, w, h, menuOption.extras["x"], menuOption.extras["y"], menuOption, menuOption.extras["fontSize"], onPointerOver, onPointerOut, onPointerLeft, onPointerRight);
            return item;
        }, null, null);
        this.listMenu.setBackground(0x0, 0.8);
    }
    cleanup(callback, option) {
        this.listMenu.destroy();
        this.listMenu = null;
        if (callback) {
            callback(option);
        }
    }
    addText(cx, cy, option_text, size = .1) {
        return KHMenuOption_1.KHMenuOption.JustText(option_text, { "x": cx, "y": cy, "fontSize": size });
    }
    addClickableOption(cx, cy, option_text, callback, size = .1) {
        return new KHMenuOption_1.KHMenuOption(option_text, null, true, callback, null, { "x": cx, "y": cy, "fontSize": size });
    }
}
exports.CGJHUDScene = CGJHUDScene;
